import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
    exports: [
            MatProgressBarModule,
            MatIconModule,
            MatToolbarModule,
            MatButtonModule,
            MatCheckboxModule,
            MatChipsModule,
            MatTableModule,
            MatSortModule,
            MatTabsModule,
            MatSidenavModule,
            MatPaginatorModule,
            MatCardModule,
            MatInputModule,
            MatSelectModule,
            MatGridListModule,
            MatExpansionModule,
            MatSlideToggleModule,
            MatRadioModule,
            MatDatepickerModule,
            MatNativeDateModule,
            MatListModule,
            MatProgressSpinnerModule,
            MatDialogModule,
            MatMenuModule,
            MatSnackBarModule,
            MatTooltipModule,
            MatFormFieldModule
            
      ]
  })
  export class MaterialModule { }